<template>
<div>           
    <div class="mt-5 py-5 border-top">
        <HeaderShop />
      <div class="row justify-content-center">
          <!-- <table id="example" class="table table-striped table-bordered" style="width:100%">
        <thead>
            <tr>
                <th v-for="(thead) in theads" :key="thead.id">
                    {{ thead }}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(tbody) in tbodys" :key="tbody.id">
                <td>{{tbody.transactions_id}}</td>
                <td>{{tbody.transactions_invoice}}</td>
                <td>{{tbody.transactions_pay}} / {{tbody.transactions_price}}</td>
                <td>
                    <span v-if="tbody.transactions_pay == 0.00" style="color:green;">สำเร็จ</span>
                    <span v-else style="color:red;">ไม่สำเร็จ</span>
                </td>
                <td>
                    <a :href="'https://services.payremind.com/taxs/'+tbody.transactions_id" target="_blank" class="text-parmiry"><i class="fa fa-file-pdf-o" aria-hidden="true"></i>&nbsp;&nbsp; ดาวน์โหลดใบกำกับภาษี</a>
                </td>
            </tr>
        </tbody>
    </table> -->
    
        
    <v-card>
 
    <v-card-title>
        <div class="row" style="margin-bottom: 10px;">
          <div class="col-md-7">
              รายการธุรกรรม
          </div>
          <div class="col-md-5" align="right">            
              <input type="search" placeholder="ค้นหา" v-model="search" class="form-control"/>
          </div>
        </div>
      <!-- <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field> -->
    
        
    </v-card-title>
    <v-data-table class="table table-hover"
      :headers="headers"
      :items="desserts"
      :search="search"
      :hide-actions="true"
      :loading="true"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.transactions_id }}</td>
        <td class="text-xs-right">{{ props.item.transactions_invoice }}</td>
        <td class="text-xs-right">{{ props.item.transactions_pay }} / {{ props.item.transactions_price }}</td>
        <td class="text-xs-right">
          <span style="font-weight: bold;color: red;" v-if="props.item.transactions_pay != 0.00">ค้างชำระ !!</span>
          <span style="font-weight: bold;color: green;" v-else>ชำระเงินแล้ว</span>
        </td>
        <td class="text-xs-right">{{ props.item.transactions_datetime }}</td>
        <td class="text-xs-right"><a :href="'https://services.payremind.com/taxs/'+props.item.transactions_id" target="_blank" class="text-parmiry"><i class="fa fa-file-pdf-o" aria-hidden="true"></i>&nbsp;&nbsp; ดาวน์โหลดใบกำกับภาษี</a></td>
      </template>
    </v-data-table>
  </v-card>
        </div>
      </div>

</div>
</template>

<script>
import Vue from 'vue';
import Vuetify from 'vuetify';
Vue.use(Vuetify)
// import VCard from 'vuetify/es5/components/VCard'; //works
// import VDataTable from 'vuetify/es5/components/VDataTable';
// import VAlert from 'vuetify/es5/components/VAlert';

// import VCardTitle from 'vuetify/es5/components/VCard/VCardTitle'; //works
// import VSelect from 'vuetify/es5/components/VSelect';
// import VTextField from 'vuetify/es5/components/VTextField';
// import VInput from 'vuetify/es5/components/VInput';
// import VMenu from 'vuetify/es5/components/VMenu';


import HeaderShop from "@/layout/shop/Header";
import Shops from "@/stores/Shops";
import router from "@/router";
const theads = [
  "#",
  "หมายเลขการสั่งซื้อ",
  "ค้างชำระ / ราคาสินค้า",
  "สถานะ",
  "เวลา",
  "จัดการ"
];
export default {
  name: "Transection",
  components: {
    HeaderShop
  },
  data() {
    return {
      theads: theads, // or theads
      // tbodys: [],
      interval: null,
      search: "",
      pagination: {
          sortBy: 'transactions_id',
          rowsPerPage:-1
      },
      headers: [
        {
          text: "#",
          align: "left",
          // sortable: false,
          value: "transactions_id"
        },
        { text: "หมายเลขการสั่งซื้อ", value: "transactions_invoice" },
        { text: "ค้างชำระ / ราคาสินค้า", value: "transactions_pay" },
        { text: "สถานะ", value: "transactions_pay" },
        { text: "เวลา", value: "transactions_datetime" },
        { text: "จัดการ", value: "action" }
      ],
      desserts: [
        // {
        //   transactions_id: "Frozen Yogurt",
        //   transactions_invoice: 159,
        //   transactions_pay: 6.0,
        //   transactions_price: 24,
        //   transactions_status: 4
        // },
      ]
    };
  },
  methods: {
    listTransections: async function() {
      if (!localStorage.access_token) router.push("/");
      let optionts = {
        access_token: localStorage.access_token,
        shops_id: this.$route.params.id
      };
      await Shops.dispatch("listTransections", optionts);
      if (Shops.state.rs_Transections.status == 200) {
        this.desserts = Shops.state.rs_Transections.data;
        // console.log(this.tbodys)
      }
    },
    todo: async function() {
      console.log("todo");
      this.interval = setInterval(() => {
        this.listTransections();
        console.log("setInterval");
      }, 5000);
    }
  },
  async mounted() {
    await this.listTransections();
    await this.todo();
    this.pagination.descending = !this.pagination.descending
  },
  async beforeDestroy() {
    await clearInterval(this.interval);
    console.log("beforeDestroy");
  }
};
</script>

<style>
 tr.v-datatable__progress {
    display: none !important;
 }
 i.v-icon{
    display: none !important;
 }
</style>